<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>
        {{ $t("message.Сервис_ключей") }}
        <sub>{{
          $t(
            "message.Внимание!_На_данный_момент_система_работает_только_с_одним_сервисом_ключей!"
          )
        }}</sub>
      </h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t("message.Главная") }}</router-link>
          </li>
          <li class="active breadcrumb-item">
            {{ $t("message.Сервисы_ключей") }}
          </li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper">
      <b-button :variant="'success'" class="mb-1 float-right" @click="addRow()">
        {{ $t("message.Добавить_сервис") }}
      </b-button>
      <b-table
        id="device-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="actions" slot-scope="row">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <b-button
            size="sm"
            @click.stop="editRow(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button
            size="sm"
            @click.stop="deleteRow(row.item, row.index, $event.target)"
          >
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
      ></b-pagination>

      <b-modal
        id="modalInfo"
        :ok-title="$t('message.Сохранить')"
        :cancel-title="$t('message.Отмена')"
        :title="$t('message.Сервисы_ключей_-_Редактирование')"
        modal-ok
        modal-cancel
        @ok="handleOk"
        no-close-on-esc
        no-close-on-backdrop
      >
        <CAS_ServerForm :model="CASServer_model"></CAS_ServerForm>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import CAS_ServerForm from "./CAS_ServerForm";

export default {
  name: "CAS_Servers",
  components: {
    CAS_ServerForm
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "id", sortable: true },
        { key: "primary_ip", sortable: true },
        { key: "primary_port", sortable: false },
        { key: "secondary_ip", sortable: true },
        { key: "secondary_port", sortable: false },
        { key: "actions", label: "", tdClass: "actions" }
      ],
      CASServer_model: {},
      cas_servers: [],
      perPage: 10,
      currentPage: 1,
      totalRows: 0
    };
  },
  methods: {
    created() {},
    dataProvider(ctx) {
      let promise = this.$noname.get("cas_servers", { params: ctx });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;
          return items;
        })
        .catch(this.unauthorized_error);
    },
    editRow(item, index, button) {
      this.CASServer_model = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    handleOk(evt) {
      evt.preventDefault();

      if (this.CASServer_model.id > 0) {
        this.$noname
          .patch("cas_servers", this.CASServer_model.id, this.CASServer_model)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "device-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      } else {
        this.$noname
          .post("cas_servers", this.CASServer_model)
          .then(Reponse => {
            this.$root.$emit("bv::refresh::table", "device-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");

            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      }
    },
    addRow() {
      this.CASServer_model = {};
      this.$root.$emit("bv::show::modal", "modalInfo");
    },
    deleteRow(item, index, button) {
      this.$dialog
        .confirm(this.$i18n.t("message.Действительно_удалить_сервис?"))
        .then(response => {
          this.$noname
            .delete("cas_servers", item.id)
            .then(response => {
              this.$root.$emit("bv::refresh::table", "device-table");
              Vue.notify({
                group: "notify",
                text: this.$i18n.t("message.Запись_успешно_удалена"),
                type: "success"
              });
            })
            .catch(error => {
              Vue.notify({
                group: "notify",
                text:
                  this.$i18n.t("message.Ошибка_удаления_записи") +
                  ":<br>" +
                  error,
                type: "error"
              });
            });
        });
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/modules/CAS_Servers.vue